import { t } from 'i18next';
import { ObjectSchema } from 'yup';
import { getEnumValues } from '../../../../services/common/miscUtils';
import Yup, { regExEmail, minMobileNumberLength, maxMobileNumberLength } from '../../../../services/common/validation';
import { CountryCodeEnum, NoYesEnum } from '../../../../types/forms';
import { PrivateProspectFormModel } from './formModel';

export const privateProspectFormSchema = (): ObjectSchema<PrivateProspectFormModel> => {
  return Yup.object({
    firstName: Yup.string().requiredWithMsg().unaccentedLetters().lengthBetween(0, 64),
    lastName: Yup.string().requiredWithMsg().unaccentedLetters().lengthBetween(0, 64),
    email: Yup.string().required(t('validation:required')).matches(regExEmail, t('validation:invalidEmail')),
    mobileNumber: Yup.string().requiredWithMsg().lengthBetween(minMobileNumberLength, maxMobileNumberLength),
    countryCode: Yup.string().requiredWithMsg().oneOf(getEnumValues(CountryCodeEnum)),
    vulnerableCustomer: Yup.boolean(),
    storeQuoteTwelveMonths: Yup.mixed<NoYesEnum>()
      .oneOf(Object.values(NoYesEnum), t('validation:required'))
      .required(t('validation:required')),
  });
};
